import AbsComponent from "../../common/AbsComponent";
import Utils from '../../common/Utils';

/**
* ServerIntergrationBanner class
* @category main
*/

// [TODO] 임시 함수. Utils의 getCookie가 쿠키의 이름이 부분적으로만 일치해도 있는 것으로 나온다.
function getCookie(name = '') {
    if (name === '') return false;

    let cookieValue = null;
    document.cookie.split('; ').forEach(cookie => {
        const [cookieName, value] = cookie.split('=');
        if (cookieName === name) {
            cookieValue = value;
        }
    });

    return cookieValue ? cookieValue : false;
}

class ServerIntergrationBanner extends AbsComponent{
    constructor(_store={}, _el='', _key){
        super(_store, _el);

        this.charServerType = this.store.data.config.charServerType;
        // 콘티에서 불러온 정보
        this.store.getData('serverIntegration', {}, this.init.bind(this));
    }

    async init(_data){

        const {isUsing, cookieName} = JSON.parse(_data.jsonData);

        this.cookieName = cookieName;

        // 사용여부 && 로그인 조건 체크 && 쿠키 있는지 확인 후 return 
        console.log('_data.isUsing', isUsing);
        console.log('isLogin', this.store.getData('config').isLogin );
        console.log('cookie', getCookie(cookieName));
        console.log('this.el', document.querySelector(this.el));

        /**
         * 콘티 정보에서, 
         * 1) 서버통합 배너 사용 했고, 
         * 2) 로그인했고, 
         * 3) 배너 더이상 안보기 안눌렀고, 
         * 4) Element 있으면, 로그인한 캐릭의 서버통합 정보 불러온다.
         */
        if(!isUsing || !this.store.getData('config').isLogin || getCookie(this.cookieName) || !document.querySelector(this.el) ){
            return;
        }

        // 유저의 데이터 받아오고 
        const infoList = await (await this.store.getDataServerIntergrationCharactorInifo());
        console.log(infoList);
        
        if( !infoList || infoList.length < 1 ){
            return;
        }

        this.render(infoList);
        this.setting();
        this.addEvents();
    }

    async render(infoList = {}) {

        // console.log('render ServerIntergrationBanner ----->', _jsonData);
        $(this.el).append(this.template( infoList ));


    }

    // 어떤 서버가 어떻게 통합 되는지에 대한 정보 전달은... 스테틱 함.
    // 만약 또 하는 경우가 있으면 바꿔 주자.
    template(infoList = {}){
        let templ = `
            <!-- contetn -->
            <div class="server-integration-content">
                <!-- close btn -->
                <div class="server-integration-btn-close">
                </div>

                <!-- top -->
                <div class="server-integration-top">
                    <div class="server-integration-title">2023년 10월 25일</div>
                    <div class="server-integration-sub-title">서버 통합으로 고객님의 일부 캐릭터가 이전되었습니다.</div>
                </div>
                <!-- mid -->
                <div class="server-integration-mid">
                    <!-- info -->
                    <div class="server-integration-info">
                        <div class="server-integration-info-gragph-wrap">
                            <div class="server-integration-info-gragph">
                                <div class="server-integration-from">
                                    <ul>
                                        <li>· 자켄</li>
                                        <li>· 신화</li>
                                    </ul>
                                </div>
                                <div class="server-integration-from-to">

                                </div>
                                <div class="server-integration-to">
                                    <p>센티넬</p>
                                </div>
                            </div>
                            <div class="server-integration-info-gragph">
                                <div class="server-integration-from">
                                    <ul>
                                        <li>· 전설</li>
                                        <li>· 오크</li>
                                    </ul>
                                </div>
                                <div class="server-integration-from-to">

                                </div>
                                <div class="server-integration-to">
                                    <p>헌터</p>
                                </div>
                            </div>
                            <div class="server-integration-info-gragph">
                                <div class="server-integration-from">
                                    <ul>
                                        <li>· 실프</li>
                                        <li>· 데스</li>
                                    </ul>
                                </div>
                                <div class="server-integration-from-to">

                                </div>
                                <div class="server-integration-to">
                                    <p>어비스</p>
                                </div>
                            </div>
                            <div class="server-integration-info-gragph">
                                <div class="server-integration-from">
                                    <ul>
                                        <li>· 윈드</li>
                                        <li>· 불멸</li>
                                    </ul>
                                </div>
                                <div class="server-integration-from-to">

                                </div>
                                <div class="server-integration-to">
                                    <p>피닉스</p>
                                </div>
                            </div>
                        </div>
                        <div class="server-integration-info-desc">
                            <p>새로워진 아덴월드에서<br class="only-mobile"> 흥미진진한 모험을 시작해보세요. <a href="https://lineage2.plaync.com/board/l2notice/view?articleId=6525f71b2787ce160312a41c">[공지보기]</a></p>
                        </div>
                    </div>
                    <div class="server-integration-character">
                        <div class="server-integration-character-head">
                            <div class="server-integration-character-content">
                                <div class="server-integration-from-server">기존 서버</div>
                                <div class="server-integration-from-characger">기존 캐릭터</div>
                                <div class="server-integration-to-characater">변경 캐릭터</div>
                            </div>
                        </div>

                        <!-- 스크롤 -->
                        <div class="server-integration-character-content-wrap">
                            ${this.template_list(infoList)}
                        </div>
                    </div>
                    <div class="server-integration-character-footer">
                        <p>· 게임에 접속해서 캐릭터명을 변경할 수 있습니다.</p>
                    </div>

                    <div class="serve-integrateion-check-close">
                        <span></span>
                        <span>그만 보기</span>
                    </div>
                </div>
            </div>

            <!-- dimmed -->
            <div class="server-integration-dimmed">

            </div>
        `; //템플릿


        return templ;
    }



    template_list(infoList){
        return infoList.reduce((temp, item)=>{
            return temp + `
                <div class="server-integration-character-content">
                    <div class="server-integration-from-server">${item.fromServerName}</div>
                    <div class="server-integration-from-characger">${item.fromCharacterName}</div>
                    <div class="server-integration-to-characater">${item.toCharacterName}</div>
                </div>
            `
        }, '')
    }

    setting(){
       document.querySelector(this.el).classList.add('show');
       document.querySelector('body').classList.add('modal-open-serverIntegration');
    }

    addEvents(){
        // 하단 다시보지 않기
        document.querySelectorAll('.serve-integrateion-check-close span').forEach((el) => {
            el.addEventListener('click', () => {
                Utils.setCookie(this.cookieName, 'true', 999);

                document.querySelector(this.el).classList.remove('show');
                document.querySelector('body').classList.remove('modal-open-serverIntegration');
            })
        });

        // 딤드
        document.querySelector('.server-integration-dimmed').addEventListener('click', ()=>{
            document.querySelector(this.el).classList.remove('show');
            document.querySelector('body').classList.remove('modal-open-serverIntegration');

        });

        // 상단 닫기 버튼
        document.querySelector('.server-integration-btn-close').addEventListener('click', ()=>{
            document.querySelector(this.el).classList.remove('show');
            document.querySelector('body').classList.remove('modal-open-serverIntegration');

        });
    }

} // end of class
export default ServerIntergrationBanner;